import React from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";

import { FileStatus } from "../../../../../../../../util/enums";
import { CustomBadge, TextValue } from "./styles";

type Props = {
  backgroundColor?: string;
  textColor?: string;
  value: string;
  dataCy?: string;
};

const SimpleBadge = (props: Props) => {
  const { value, backgroundColor, textColor, dataCy } = props;

  return (
    <CustomBadge backgroundColor={backgroundColor}>
      <TextValue textColor={textColor} data-cy={dataCy}>
        {value}
      </TextValue>
    </CustomBadge>
  );
};

export const BadgeCVSUpload = (props: Props) => {
  const { dataCy, value } = props;
  const { t: translate } = useTranslation();
  const formatted = translate(value);

  switch (value) {
    case FileStatus.CSV_UPLOADED:
      return (
        <SimpleBadge
          backgroundColor={colors.success50}
          dataCy={dataCy}
          textColor={colors.success600}
          value={formatted}
        />
      );
    case FileStatus.SHIPEEZI_DEFAULT:
      return (
        <SimpleBadge
          backgroundColor={colors.brandBlue50}
          dataCy={dataCy}
          textColor={colors.brandBlue600}
          value={formatted}
        />
      );
    case FileStatus.WAITING_UPDATE:
      return (
        <SimpleBadge
          backgroundColor={colors.warning50}
          dataCy={dataCy}
          textColor={colors.warning600}
          value={formatted}
        />
      );
    default:
      return (
        <SimpleBadge
          backgroundColor={colors.success50}
          dataCy={dataCy}
          textColor={colors.success600}
          value={formatted}
        />
      );
  }
};
